export const environment = {
	appName: 'Wap',
	home: '/painel/user',
	production: false,

	api: 'https://api-wap.actionlabs.com.br/api/1.0',
	url: 'https://wap.actionlabs.com.br',

	passwordRules: {
		minlength: 6,
		minLowercaseCharacterRule: 1,
		minUppercaseCharacterRule: 1,
		minDigitCharacterRule: 1,
		minSpecialCharacterRule: 1
	},

	firebaseConfig: {
		apiKey: "AIzaSyAuVP3S3WTtmooQ26AQ8HZw4AcVRm539Bs",
		authDomain: "wap-homolog.firebaseapp.com",
		projectId: "wap-homolog",
		storageBucket: "wap-homolog.firebasestorage.app",
		messagingSenderId: "484483080753",
		appId: "1:484483080753:web:a6aba53edb77a6507beb10"
	},

	title: 'Wap',
	description: ``,
	image: '',
	keywords: ''
};
